import { SendMailParams } from "./models/mail";
import { environment as env } from '../environments/environment';

export const productionTitle = 'CrewTime'
const crewtimeLink = 'https://crewtime.app'
const financeEmail = ''
const pmEmail = ''
export const invoiceMainualLink = 'https://drive.google.com/'
export const config = {
    dev: { name: "SÓS András", email: 'sosandris@gmail.com' },
    /** Ha ezek a userek közül van valaki bejelentkezve, 
     * akkor email küldés előtt kérdezz rá, hogy biztos ki akarja-e küldeni. 
     * Jó eséllyel csak tesztelgetünk, és nem akarjuk ténylegesen elküldeni az emailt. */
    DONT_SEND_MAIL: [/^sosandris@gmail.com$/, /@tu.tu$/, /^sergeikov@gmail.com$/, /^zoltantokey@gmail.com$/],
    SHOW_GROWING_OTTA_RATE: false,
    CONFIG_PERSONAL_END_DATES: true,
    AUTOFILL_CONTRACT_DATES: true,
    HAS_FOREIGN_CREW: false,
    ALLOW_TRAVELDAY: false,

    ALLOW_CREW_MEMBER_EDIT_FEES: false,
    DISABLE_OLD_TS: false,
    DISABLE_OLD_TS_OT: false,
    DISABLE_OLD_TS_PREP_WEEKS: 2 as false | number,
    DISABLE_OLD_TS_SHOOTING_WEEKS: 2 as false | number,
    ALLOW_CREW_MEMBER_EDIT_OT_STEP: false,
    ALLOW_CREW_MEMBER_EDIT_TA_FEE: false,
    ALLOW_CREW_MEMBER_EDIT_CONTRACT_DATES: false,
    ALLLOW_CONTRACT_END_DATE: true,
    ALLOW_PERDIEM: true,
    ALLOW_OT_PERCENT: true,
    OT_PERCENT: 15,
    ALLOW_TA_PERCENT: true,
    TA_PERCENT: 15,
    ALLOW_REST_DAY: true,
    PERDIEM_MULTIPLIER_FOR_REST_DAY: 1,
    HUF_PER_KM: 65,
    REPORT: {
        CURRENCY: 'EUR' as string | undefined,
    },
    
    /** 'fixed-rates': Nem adható meg naponta új árfolyam. Ha több mint 2 pénznem van, akkor csak ez választható, mert a napi árfolyam mentésekor nem adható meg, hogy melyik pénznam árfolyamát mented */
    MULTIPLE_CURRENCIES: 'fixed-rates' as 'fixed-rates' | boolean,

    DISABLED_TS_HISTORY_TEXT: 'Letiltva',
    
    HU: {
        CONTRACT: {
            ENABLE_FILTER_FINANCE_APPROVED: true,
            CONTRACT_GEN_FEATURE: true,
            ALLOW_PROD_MGR_APPROVE_UNSUBMITTED_CONTRACT: true,
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Start Form visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A Start Formodat {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            SEND_MAIL_FOR_APPROVED: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Start Form elfogadva`,
                body: `Kedves Andi!<br><br>A következő Start Formot jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            },
            SEND_MAIL_FINANCE_NOTIF_NEW_POSITION: {
                enabled: false,
                sendTo: financeEmail,
                subject: `[${productionTitle}] Új pozíció jóváhagyva`,
                body: `Sziasztok! <br><br> A következő Start Formot új pozícióval, de megegyező céggel jóváhagyták: {START_FORM}. Megtekintheted a ${crewtimeLink} címen.<br><br>Üdvözlettel!<br>CrewTime`,
            }
        },
        M30: {
            EMAIL: {
                DISPLAY_SEND_M30_BUTTON: false,
                MOCK_SEND: true,
                SUBJECT: `Proton Crewtime ${new Date().getFullYear() - 1}M30 dokumentum`,
                BODY: `<p><em>Kedves St&aacute;btagunk,</em></p>
<p><em>jelen lev&eacute;lben k&uuml;ldj&uuml;k ${new Date().getFullYear() - 1}-&ouml;s &eacute;vi M30-as dokumentumodat, amelyet az al&aacute;bbi linken tudsz let&ouml;lteni.</em></p>
<p><em><a href="https://crewtime.app/my/m30">https://crewtime.app/my/m30</a></em></p>
<p><em>Bel&eacute;p&eacute;s:&nbsp;</em></p>
<ul>
<li><em>Felhaszn&aacute;l&oacute;n&eacute;v: az emailc&iacute;med, melyre ezt az &eacute;rtes&iacute;t&eacute;st kaptad</em></li>
<li><em>Jelsz&oacute;: az ad&oacute;azonos&iacute;t&oacute;d ( a t&aacute;rsash&aacute;z eset&eacute;n az ad&oacute;sz&aacute;m első nyolc sz&aacute;mjegye).</em></li>
</ul>
<p><em>Erre az emailre NE válaszolj! Amennyiben pap&iacute;r alapon szeretn&eacute;d megkapni a dokumentumot, vagy b&aacute;rmilyen egy&eacute;b k&eacute;rd&eacute;sed lenne, k&eacute;rlek, &iacute;rj nek&uuml;nk a <a href="mailto:hello@protoncinema.hu" target="_blank" rel="noreferrer">hello@protoncinema.hu</a> emailc&iacute;mre.</em></p>
<p><em>&Uuml;dv&ouml;zlettel</em></p>
<p><em>Proton Cinema p&eacute;nz&uuml;gy</em></p>`,
            }
        },
        USER: {
            SEND_MAIL_FOR_REG_ACCEPTED: {
                subject: `[${productionTitle}] Regisztráció elfogadva`,
                body: `Kedves {USERNAME}!<br><br>A regisztrációdat elfogadtuk. Kérlek, töltsd ki a start formodat a ${crewtimeLink} címen.<br><br>Köszönjük!<br>CrewTime`,
            },
        },
        TS: {
            SEND_MAIL_FOR_SENDBACK_TO_CREW: {
                ccTo: pmEmail,
                subject: `[${productionTitle}] Timesheet visszaküldve`,
                body: `Kedves {USERNAME}!<br><br>A Timesheetedet {FROM_USER} visszaküldte javításra. Kérlek, javítsd ki a hibákat, és küldd be újra a ${crewtimeLink} címen.`,
                bodyEnding: '<br><br>Köszönjük!<br>CrewTime',
            },
            /** timeFromCrewCallFirstValueableOtRate: a crew calltól számított x idő után jár egy egyösszegű díj. Az összeg az első órára járó túlóra díjával egyezik meg
             * Az összeg az első órára járó túlóra díjával egyezik meg
             * setAtProdDeptSf: A produkció / részleg start formján beállított összeg kerül kiszámolásra
             * false: nem jár senkinek
             */
        //  MEAL_PENALTY: 'timeFromCrewCallFirstValueableOtRate' as 'firstValueableOtRate' | 'setAtProdDeptSf' | 'timeFromCrewCallFirstValueableOtRate' | false,
            MEAL_PENALTY: 'firstValueableOtRate' as 'firstValueableOtRate' | 'setAtProdDeptSf' | 'timeFromCrewCallFirstValueableOtRate' | false,
            /** A Crew Calltól számított hány óó:pp után kapja a MEAL_PENALTY-t
             * Csak ha a timeFromCrewCall van beállítva a MEAL_PENALTY-nek */
            MEAL_PENALTY_START_AFTER_CREW_CALL: '6:15',
            /** A start formban megjelenő label szöveg. Ha null, akkor a dictionary-ből jön ("meal-penalty-label"-> Meal Penalty egy teljes órára) */
            MEAL_PENALTY_SF_LABEL: 'Meal Penalty' as null | string,
            DISPLAY_KM_PARKING_VIGN_IN_CALCULATED_SECTION: true,
            // Ha nem kell pénzügyes jóváhagyás, akkor , 
            ALLOW_SUBMIT_BEFORE_APPROVAL: false,
            WARN_NUM_CONSEQ_DAYS: 6 as number | false,
            HIDE_KM_FEE: false,
        },
    },
} as const

export const POLICIES = {
    PRIVACY_POLICY: {
        hu: { title: 'Adatvédelmi Szabályzat', url: 'https://drive.google.com/file/d/1qZR5Ze1VmVhDiFo_H8-1XriuxahfeOI6/view?usp=drive_link' },
        en: { title: 'Privacy Policy', url: 'https://drive.google.com/file/d/1qZR5Ze1VmVhDiFo_H8-1XriuxahfeOI6/view?usp=drive_link' },
    },
    /** Terms & Conditions */
    GENERAL_TC: {
        hu: { title: 'Általános Szerződési Feltételek', url: null},
        en: { title: 'General Terms & Conditions', url: null},
    },
    HARASSMENT: {
        hu: { title: 'Zaklatás elleni irányelvek', url: 'https://docs.google.com/document/d/1r1ZGSS4VOi2jufSH62D4QdUfr_9zDima/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Harassment Policy', url: 'https://docs.google.com/document/d/1r1ZGSS4VOi2jufSH62D4QdUfr_9zDima/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    ETHICS: {
        hu: { title: 'Etikai irányelvek', url: 'https://docs.google.com/document/d/1KzmvMZM-oVbCAfA-MAHgszygCQ5_65Hs/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Ethics Policy', url: 'https://docs.google.com/document/d/1KzmvMZM-oVbCAfA-MAHgszygCQ5_65Hs/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    NDA: {
        hu: { title: 'Titoktartási Megállapodás', url: 'https://docs.google.com/document/d/1Kr13efupYwy8Z5JCm991DlJErasLyPUf/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Non-Disclosure Agreement', url: 'https://docs.google.com/document/d/1h6qpX3RKDXGsNTdVDR3Fe1a9CebqHk4r/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    HEALTH_AND_SAFETY: {
        hu: { title: 'Egészség és Biztonság', url: 'https://docs.google.com/document/d/1qcqmNOZ9mTqPmQdxRCY8WgdWGuHMPjle/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Health and Safety', url: 'https://docs.google.com/document/d/1sP8WGwm9l2FsQr7GqKGGxUIDHBJ9zACL/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    EQUALITY_DIVERSITY_INCLUSION: {
        hu: { title: 'Egyenlőség, Sokszínűség és Befogadás', url: 'https://docs.google.com/document/d/1dUdqNmXz8A-gwIw1-4XHt7lKACZynJmf/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Equality, Diversity and Inclusion', url: 'https://docs.google.com/document/d/1prUQ_T7B0qmFcW9kWgkap9TEzXfQN8Fw/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    DATA_PRIVACY: {
        hu: { title: 'Adatvédelem', url: 'https://docs.google.com/document/d/1_IJjvL_aAbYtQ48UcGvUL9nJ-bJL3cKg/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Data Privacy', url: 'https://docs.google.com/document/d/1rfegEILGSy_8HM6fFa_I8Gs-Pr828Dkc/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
    ANTI_BRIBERY: {
        hu: { title: 'Visszaélés elleni irányelvek', url: 'https://docs.google.com/document/d/1zCu_flgsU7sU8oXpD-6zNgEdUmNFn4Rv/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
        en: { title: 'Anti-Bribery Policy', url: 'https://docs.google.com/document/d/18KhDHckkfn1yxvoCVK5Id9seKWhHHzak/edit?usp=drive_link&ouid=107918629467201434763&rtpof=true&sd=true', },
    },
} as const

export const IS_RAGE = (productionTitle as unknown == 'RAGE' as const)
export const IS_DENNIS = (productionTitle as unknown == 'Dennis' as const)